import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

const sensitivityConfig = {
  offen: {
    color: 'success',
    labelKey: 'dataCatalog.sensitivity.levels.offen',
    tooltipKey: 'dataCatalog.sensitivity.tooltips.offen',
  },
  pseudonymisiert: {
    color: 'info',
    labelKey: 'dataCatalog.sensitivity.levels.pseudonymisiert',
    tooltipKey: 'dataCatalog.sensitivity.tooltips.pseudonymisiert',
  },
  anonymisiert: {
    color: 'default',
    labelKey: 'dataCatalog.sensitivity.levels.anonymisiert',
    tooltipKey: 'dataCatalog.sensitivity.tooltips.anonymisiert',
  },
  vertraulich: {
    color: 'warning',
    labelKey: 'dataCatalog.sensitivity.levels.vertraulich',
    tooltipKey: 'dataCatalog.sensitivity.tooltips.vertraulich',
  },
  'streng vertraulich': {
    color: 'error',
    labelKey: 'dataCatalog.sensitivity.levels.strictlyConfidential',
    tooltipKey: 'dataCatalog.sensitivity.tooltips.strictlyConfidential',
  },
};

const SensitivityBadge = ({ level, size = 'small', variant = 'outlined' }) => {
  const { t } = useTranslation();
  const config = sensitivityConfig[level] || sensitivityConfig['pseudonymisiert'];

  return (
    <Tooltip title={t(config.tooltipKey)}>
      <Chip
        label={t(config.labelKey)}
        color={config.color}
        size={size}
        variant={variant}
      />
    </Tooltip>
  );
};

export default SensitivityBadge;
